<template>
  <div class="shuffled game-room container" v-if="roomInfo">
    <div class="full-page-background"></div>
    <div v-html="customOptions.style"></div>

    <!-- Menu Bar -->
    <div class="menu-bar mb-4 d-flex align-items-center">
      <button class="btn btn-outline-dark mr-auto border-0" v-b-modal.menuModal v-bind:style="{color: 'white'}"><b-icon-list></b-icon-list> Menu</button>
      <!-- <div v-if="customOptions.gameTitle" class="mx-auto align-middle text-center">{{customOptions.gameTitle}}</div> -->
      <app-roomLink class="d-none d-sm-block" :routeRoomID="$route.params.roomID" :color="'white'" v-if="dataReady && firebaseReady"></app-roomLink>

      <b-modal
        id="menuModal"
        :title="customOptions.gameTitle ? customOptions.gameTitle : 'Menu'"
        hide-footer
      >
        <b-container>
          <div class="row menu-row">
            <b-button
              class="border-0 btn-lg btn-block"
              v-on:click="copyLinkToClipboard(); closeMenu();"
              @click="$bvToast.show('copyToast')"
            >
              <b-icon-link45deg></b-icon-link45deg> Copy URL
            </b-button>
          </div>
          <div class="row menu-row">
            <b-button
              v-b-modal.reshuffleConfirm
              v-on:click="closeMenu();"
              class="control-button-restart btn-lg btn-block"
              variant="outline-dark"
              :disabled="roomInfo.xCardIsActive"
              v-if="!customOptions.facilitatorMode || userRole == 'facilitator'"
              color="rgb(187, 138, 200)"
              >Restart</b-button
            >
          </div>
          <div class="row menu-row">
            <b-button
              variant="outline-dark"
              class="control-button-safety-card btn-lg btn-block"
              v-on:click="xCard(); closeMenu();"
              v-html="
                customOptions.safetyCardButton
                  ? customOptions.safetyCardButton
                  : 'X-Card'
              "
              ></b-button>
          </div>
          <div class="row menu-row">
            <b-button
              v-on:click="nextDeck(); closeMenu();"
              variant="outline-dark"
              class="control-button-next-deck btn-lg btn-block"

              v-if="this.customOptions.showNextDeckButton && (!customOptions.facilitatorMode || userRole == 'facilitator')"
              :disabled="
                roomInfo.xCardIsActive ||
                  roomInfo.currentCardIndex >= roomInfo.locationOfLastCard
              "
              v-html="
                customOptions.showNextDeckButton
                  ? customOptions.showNextDeckButton
                  : 'Next Deck'
              "
            ></b-button>
          </div>
          <div v-if="!this.customOptions.showNextDeckButton && (!customOptions.facilitatorMode || userRole == 'facilitator') && (!customOptions.hideNavigationButtons)">
            <hr class='mb-4'/>
            <h6 class='text-center'>{{customOptions.lastCardLabel}} Options</h6>
            <div class="row menu-row">

              <b-button class="btn-block" v-on:click="lastCard(); closeMenu();"
              :disabled="
                roomInfo.xCardIsActive ||
                  roomInfo.currentCardIndex == gSheet.length - 1 ||
                  roomInfo.currentCardIndex == roomInfo.locationOfLastCard
              "
              >
                Go to {{customOptions.lastCardLabel}}
              </b-button>

              <b-button class="btn-block" v-on:click="shuffleLastCard('center'); closeMenu();"
              :disabled="
                roomInfo.xCardIsActive ||
                  roomInfo.currentCardIndex == gSheet.length - 1 ||
                  roomInfo.currentCardIndex == roomInfo.locationOfLastCard
              "
              >
                Shuffle near middle
              </b-button>

              <b-button class="btn-block" v-on:click="shuffleLastCard('end'); closeMenu();"
              :disabled="
                roomInfo.xCardIsActive ||
                  roomInfo.currentCardIndex == gSheet.length - 1 ||
                  roomInfo.currentCardIndex == roomInfo.locationOfLastCard
              ">
                Shuffle near end
              </b-button>

            </div>
          </div>
        </b-container>
        <div class="" v-if="customOptions.modalOneLabel || customOptions.modalTwoLabel">
          <hr class='mb-4'/>
          <b-button
            v-b-modal.modalOne
            v-on:click="closeMenu();"
            variant="outline-dark"
            class="btn-block btn-lg"
            v-if="customOptions.modalOneLabel"
          >
            {{ customOptions.modalOneLabel }}
          </b-button>
          <b-button
            v-b-modal.modalTwo
            v-on:click="closeMenu();"
            variant="outline-dark"
            class="btn-block btn-lg"
            v-if="customOptions.modalTwoLabel"
            >{{ customOptions.modalTwoLabel }}</b-button
          >
        </div>
        <div class="row menu-row mt-4">
          <a href="https://storysynth.org" target="_blank">Powered by Story Synth</a>
        </div>
      </b-modal>
    </div>

    <b-alert show class="" variant="danger" v-if="firebaseCacheError">Warning: the length of the deck has changed since this room was first created. Click Restart to resync card data.</b-alert>
    <b-alert show class="demoInfo" variant="info" v-if="customOptions.demoInfo">This demo is powered by <a :href="customOptions.demoInfo" target="_blank">this Google Sheet Template</a>. Copy the sheet and start editing it to design your own game!</b-alert>
    <div class="" v-if="roomInfo">
      <div class="before-game-card">
        <!-- <div
          class="mb-4 game-meta d-none d-sm-block"
          v-if="
            !customOptions.hideTitleInSession &&
              (customOptions.gameTitle || customOptions.byline)
          "
        >
          <div class="row text-center" v-if="customOptions.gameTitle">
            <div class="col-sm">
              <h1 class="game-title">{{ customOptions.gameTitle }}</h1>
            </div>
          </div>

          <div class="row text-center" v-if="customOptions.byline">
            <div class="col-sm">
              <h4 class="game-byline">{{ customOptions.byline }}</h4>
            </div>
          </div>
        </div> -->

        <!-- TODO: Facilitator Notes
        <div class="facilitator-panel" v-if="userRole == 'facilitator' && customOptions.facilitatorMode">
          <h1>Faciliator</h1>
        </div>
        -->

        <div
          v-if="
            dataReady &&
              firebaseReady &&
              roomInfo &&
              Object.keys(roomInfo.extensionData).length > 1
          "
        >
          <app-extensionManager
            @sync-extension="syncExtension()"
            :extensionData="roomInfo.extensionData"
            :extensionList="tempExtensionData"
            :roomInfo="roomInfo"
            :extensionLocation="'upper'"
            class="extension-upper"
          ></app-extensionManager>
        </div>

        <!-- <div class="row card-navigation-buttons card-nav-above mb-4" v-if="(!customOptions.facilitatorMode || userRole == 'facilitator') && (!customOptions.lowerCardNavOnMobile) && (!customOptions.hideNavigationButtons || (parseInt(customOptions.hideNavigationButtons) > roomInfo.currentCardIndex))">
          <transition name="fade">
            <div class="btn-group col-sm" role="group" aria-label="Card Controls">
              <button
                class="btn btn-outline-dark control-button-previous-card"
                v-on:click="previousCard()"
                :disabled="
                  roomInfo.xCardIsActive || roomInfo.currentCardIndex == 0
                "
              >
                Previous Card
              </button>
              <button
                class="btn btn-outline-dark control-button-next-card"
                v-on:click="nextCard()"
                :disabled="
                  roomInfo.xCardIsActive ||
                    roomInfo.currentCardIndex >= roomInfo.locationOfLastCard
                "
              >
                Next Card
              </button>
            </div>
          </transition>
        </div> -->

        <transition name="fade">
        <div class="fab-buttons container" v-if="(!customOptions.facilitatorMode || userRole == 'facilitator') && (!customOptions.hideNavigationButtons || (parseInt(customOptions.hideNavigationButtons) > roomInfo.currentCardIndex))">
            <button
              class="btn btn-outline-dark btn-fab btn-fab-left control-button-previous-card shadow"
              v-on:click="previousCard()"
              v-b-tooltip.hover title="Previous Card"
              :disabled="
                roomInfo.xCardIsActive || roomInfo.currentCardIndex == 0
              "
            >
              <!-- Previous Card -->
              <b-icon class="h1 mb-0" icon="chevron-left"></b-icon>
              <b-icon class="h1 mb-0 mr-2" icon="card-heading"></b-icon>
            </button>
            <button
              class="btn btn-outline-dark btn-fab btn-fab-right control-button-next-card shadow"
              v-b-tooltip.hover title="Next Card"
              v-on:click="nextCard()"
              :disabled="
                roomInfo.xCardIsActive ||
                  roomInfo.currentCardIndex >= roomInfo.locationOfLastCard
              "
            >
              <!-- Next Card -->
              <b-icon class="h1 mb-0 ml-2" icon="card-heading"></b-icon>
              <b-icon class="h1 mb-0" icon="chevron-right"></b-icon>
            </button>
        </div>
      </transition>

        <div class="row mb-3 game-meta card-counter" v-if="customOptions.displayCardCount && customOptions.displayCardCount - 1 <= roomInfo.currentCardIndex && roomInfo.currentCardIndex < roomInfo.locationOfLastCard">
          <div class="col-sm">
            <h2><span v-if="customOptions.displayCardCountLabel">{{customOptions.displayCardCountLabel}}</span><span v-else>Cards seen:</span> {{roomInfo.currentCardIndex - customOptions.displayCardCount + 1}}</h2>
          </div>
        </div>
      </div>

      <transition name="fade">
        <div
          class="card main-card d-flex shadow img-fluid mb-4"
          v-bind:class="{
            'bg-transparent':
              customOptions.coverImage && roomInfo.currentCardIndex == 0,
          }"
          v-if="gSheet[roomInfo.cardSequence[roomInfo.currentCardIndex]]"
        >
          <!-- card images -->
          <img
            v-bind:src="customOptions.coverImage"
            class="card-img-top"
            style="width:100%"
            v-if="customOptions.coverImage && roomInfo.currentCardIndex == 0"
          />
          <img
            v-bind:src="customOptions.cardBackgroundImage"
            class="card-img-top card-background"
            style="width:100%"
            v-if="
              customOptions.cardBackgroundImage &&
                (!customOptions.coverImage ||
                  roomInfo.currentCardIndex != 0) &&
                !customOptions.cardBackgroundImageAlign
            "
          />
          <b-card-img
            v-bind:src="customOptions.cardBackgroundImage"
            alt="Card Background image"
            top
            v-if="
              customOptions.cardBackgroundImageAlign == 'top' &&
                roomInfo.currentCardIndex != 0
            "
          ></b-card-img>


          <!-- Loading Visual -->
          <div
            class="card-body text-center"
            v-if="(!dataReady || !firebaseReady) && !error"
          >
            <h1 class="m-5">Loading</h1>
            <b-spinner
              class="m-5"
              style="width: 4rem; height: 4rem;"
              label="Busy"
            ></b-spinner>

            <div v-if="customOptions.debugLoading == 'TRUE'">
              <div>Google Sheet ready: {{dataReady}}</div>
              <div>Firebase ready: {{firebaseReady}}</div>
              <div>Error: {{error}}</div>
            </div>
          </div>

          <div
            class="row mt-4 mx-4 game-meta"
            v-if="
              customOptions.instructionsProgressBar &&
                roomInfo.currentCardIndex < firstNonInstruction &&
                roomInfo.currentCardIndex != 0
            "
          >
            <div class="col-sm">
              <h3>Instructions</h3>
              <b-progress
                :value="roomInfo.currentCardIndex"
                :max="firstNonInstruction - 1"
                variant="dark"
              ></b-progress>
            </div>
          </div>

          <!-- Main Game Cards -->
          <div
            v-if="!customOptions.coverImage || roomInfo.currentCardIndex != 0"
            v-bind:class="gSheet[roomInfo.cardSequence[roomInfo.currentCardIndex]]
                      .deckNumberClass"
          >
            <div
              class="card-body justify-content-center d-flex align-items-center mt-4"
              style="white-space: pre-line"
              v-bind:class="{
                'card-img-overlay':
                  customOptions.cardBackgroundImage &&
                  !customOptions.cardBackgroundImageAlign,
              }"
              v-if="!roomInfo.xCardIsActive"
            >
              <div v-if="!roomInfo.showCardBack">
                <h1 v-if="!customOptions.hideHeadersOnCards">
                  {{
                    gSheet[roomInfo.cardSequence[roomInfo.currentCardIndex]]
                      .headerText
                  }}
                </h1>
                <p
                  class="mt-4 mb-4"
                  v-html="
                    gSheet[roomInfo.cardSequence[roomInfo.currentCardIndex]]
                      .bodyText
                  "
                ></p>
                <button class="btn btn-outline-dark" v-on:click="flipCard()" v-if="gSheet[roomInfo.cardSequence[roomInfo.currentCardIndex]].cardBack && customOptions.reversableCards">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                    <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
                  </svg>
                </button>
              </div>
              <div v-else>
                <div class="mt-4 mb-4" v-html="gSheet[roomInfo.cardSequence[roomInfo.currentCardIndex]].cardBack">
                </div>
                <button class="btn btn-outline-dark" v-on:click="flipCard()" v-if="gSheet[roomInfo.cardSequence[roomInfo.currentCardIndex]].cardBack && customOptions.reversableCards">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                    <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <b-alert show class="mx-3" v-html="customOptions.lastCardReminderText" variant="info" v-if="customOptions.lastCardReminderText && customOptions.lastCardReminderFrequency && roomInfo.currentCardIndex > firstNonInstruction && ((roomInfo.currentCardIndex - firstNonInstruction) % customOptions.lastCardReminderFrequency == customOptions.lastCardReminderFrequency - 1)"></b-alert>

          <!-- Safety Card -->
          <div
            class="card-body align-items-center justify-content-center"
            v-if="roomInfo.xCardIsActive"
            v-bind:class="{
              'card-body': !customOptions.cardBackgroundImage,
              'card-img-overlay':
                customOptions.cardBackgroundImage &&
                !customOptions.cardBackgroundImageAlign,
            }"
          >
            <div class="mt-5 pt-5 mb-5">
              <h1 v-if="!customOptions.safetyCardText">X-Card</h1>
              <div
                class="safety-card-text"
                v-html="customOptions.safetyCardText"
                v-if="customOptions.safetyCardText"
              ></div>
            </div>
            <button class="btn btn-outline-dark mt-5" v-on:click="xCard()">
              Continue
            </button>
            <div class="" v-if="!customOptions.safetyCardText">
              <a class="x-card-text" href="http://tinyurl.com/x-card-rpg"
                >About the X-Card</a
              >
            </div>
          </div>

          <!-- Card Image, Bottom -->
          <b-card-img
            v-bind:src="customOptions.cardBackgroundImage"
            alt="Card Background image"
            bottom
            v-if="
              customOptions.cardBackgroundImageAlign == 'bottom' &&
                roomInfo.currentCardIndex != 0
            "
          ></b-card-img>
        </div>
      </transition>


      <div class="after-game-card">
        <!-- <b-button-toolbar class="justify-content-between lower-buttons" v-if="!customOptions.facilitatorMode || userRole == 'facilitator'">
          <b-button-group class="game-meta-buttons" aria-role="Deck control" v-bind:class="{'d-flex w-100': !customOptions.lowerCardNavOnMobile}">
            <b-button
              v-b-modal.reshuffleConfirm
              class="control-button-restart"
              variant="outline-dark"
              :disabled="roomInfo.xCardIsActive"
              v-if="!customOptions.facilitatorMode || userRole == 'facilitator'"
              color="rgb(187, 138, 200)"
              >Restart</b-button
            >
            <b-button
              variant="outline-dark"
              class="control-button-safety-card"
              v-on:click="xCard()"
              v-html="
                customOptions.safetyCardButton
                  ? customOptions.safetyCardButton
                  : 'X-Card'
              "
              ></b-button>
            <b-button
              v-b-modal.modalNextDeckConfirm
              variant="outline-dark"
              class="control-button-next-deck"

              v-if="this.customOptions.showNextDeckButton && (!customOptions.facilitatorMode || userRole == 'facilitator')"
              :disabled="
                roomInfo.xCardIsActive ||
                  roomInfo.currentCardIndex >= roomInfo.locationOfLastCard
              "
              v-html="
                customOptions.showNextDeckButton
                  ? customOptions.showNextDeckButton
                  : 'Next Deck'
              "
            ></b-button>
            <b-dropdown
              variant="outline-dark"
              id="dropdown-1"
              class="control-button-last-card"
              v-bind:text="customOptions.lastCardLabel"
              :disabled="
                roomInfo.xCardIsActive ||
                  roomInfo.currentCardIndex == gSheet.length - 1 ||
                  roomInfo.currentCardIndex == roomInfo.locationOfLastCard
              "
              v-if="!this.customOptions.showNextDeckButton && (!customOptions.facilitatorMode || userRole == 'facilitator') && (!customOptions.hideNavigationButtons)"
              right
            >
              <b-dropdown-item v-on:click="lastCard()"
                >Go to {{customOptions.lastCardLabel}}</b-dropdown-item
              >
              <b-dropdown-item v-on:click="shuffleLastCard('center')"
                >Shuffle near middle</b-dropdown-item
              >
              <b-dropdown-item v-on:click="shuffleLastCard('end')"
                >Shuffle near end</b-dropdown-item
              >
            </b-dropdown>
          </b-button-group>
          <b-button-group class="btn-group card-navigation-buttons card-nav-below" role="group" aria-label="Card Controls" v-if="customOptions.lowerCardNavOnMobile">
            <b-button
              class="btn btn-outline-dark control-button-previous-card"
              v-on:click="previousCard()"
              :disabled="
                roomInfo.xCardIsActive || roomInfo.currentCardIndex == 0
              "
            >
              &lsaquo;
            </b-button>
            <b-button
              class="btn btn-outline-dark control-button-next-card"
              v-on:click="nextCard()"
              :disabled="
                roomInfo.xCardIsActive ||
                  roomInfo.currentCardIndex >= roomInfo.locationOfLastCard
              "
            >
              &rsaquo;
            </b-button>
          </b-button-group>
        </b-button-toolbar> -->

        <div
          v-if="
            dataReady &&
              firebaseReady &&
              roomInfo &&
              Object.keys(roomInfo.extensionData).length > 1
          "
        >
          <app-extensionManager
            @sync-extension="syncExtension()"
            :extensionData="roomInfo.extensionData"
            :extensionList="tempExtensionData"
            :roomInfo="roomInfo"
            :extensionLocation="'lower'"
            class="extension-lower"
          ></app-extensionManager>
        </div>



        <b-modal
          id="modalOne"
          v-bind:title="customOptions.modalOneLabel"
          hide-footer
        >
          <div
            class="d-block text-left"
            v-html="customOptions.modalOneText"
          ></div>
        </b-modal>

        <b-modal
          id="modalTwo"
          v-bind:title="customOptions.modalTwoLabel"
          hide-footer
        >
          <div
            class="d-block text-left"
            v-html="customOptions.modalTwoText"
          ></div>
        </b-modal>


        <b-modal
          id="modalNextDeckConfirm"
          title="Advance?"
          hide-footer
        >
          <p></p>
          <div
            class="text-center mb-3"
          >
            <b-button
              variant="dark"
              v-on:click="nextDeck()"
              >Advance to {{customOptions.showNextDeckButton
                          ? customOptions.showNextDeckButton
                          : 'Next Deck'}}</b-button
            >
          </div>
        </b-modal>
        <b-modal
          id="reshuffleConfirm"
          title="Restart and Reshuffle"
          hide-footer
        >
          <p>Do you want to reshuffle all of the prompts and restart the game?</p>
          <div
            class="text-center mb-3"
          >
            <b-button
              variant="dark"
              v-on:click="shuffleAndResetGame()"
              >Restart and Reshuffle</b-button
            >
          </div>
        </b-modal>

      </div>
    </div>
  </div>
</template>

<script>
import { roomsCollection } from "../../firebase";
import ExtensionManager from "../extensions/ExtensionManager.vue";
import RoomLink from '../layout/RoomLink.vue';

export default {
  name: "app-shuffled",
  components: {
    "app-extensionManager": ExtensionManager,
    'app-roomLink': RoomLink,
  },
  props: {
    roomID: String,
    gSheetID: String,
  },
  data: function() {
    return {
      roomInfo: {
        currentCardIndex: 0,
        xCardIsActive: false,
        cardSequence: [0, 1, 2],
        locationOfLastCard: 0,
      },
      firstNonInstruction: 0,
      tempExtensionData: { test: null },
      dataReady: false,
      firebaseReady: false,
      firebaseCacheError: false,
      gSheet: [{ text: "loading" }],
      orderedCards: [],
      currentDeck: 0,
      totalDecks: 0,
      unorderedDecks: {},
      customOptions: {
        lastCardLabel: "Last Card"
      },
      error: false,
    };
  },
  metaInfo() {
    return {
      title: this.customOptions.gameTitle,
      meta: [
        {
          property: "description",
          content: this.customOptions.gameBlurb,
          vmid: "description",
        },
        {
          property: "og:title",
          content: this.customOptions.gameTitle,
          vmid: "og:title",
        },
        {
          property: "og:description",
          content: this.customOptions.gameBlurb,
          vmid: "og:description",
        },
        {
          property: "og:image",
          content: this.customOptions.ogImageSquare,
          vmid: "og:image",
        },
        {
          property: "og:url",
          content: "https://storysynth.org/#" + this.$route.fullPath,
          vmid: "og:url",
        },
        {
          property: "twitter:card",
          content: "summary",
          vmid: "twitter:card",
        },
        {
          property: "og:site_name",
          content: "Story Synth",
          vmid: "og:site_name",
        },
        {
          property: "twitter:image:alt",
          content: this.customOptions.gameTitle + " logo",
          vmid: "twitter:image:alt",
        },
        {
          name: "monetization",
          content: this.customOptions.wallet,
          vmid: "monetization",
        },
      ],
    };
  },
  mounted() {
    this.fetchAndCleanSheetData(this.gSheetID);

    this.$bind("roomInfo", roomsCollection.doc(this.roomID))
      .then(() => {
        this.firebaseReady = true;
      })
      .then(() => {
        if (!this.roomInfo) {
          console.log("new room!");

          roomsCollection
            .doc(this.roomID)
            .set({
              extensionData: this.tempExtensionData,
              currentCardIndex: 0,
              xCardIsActive: false,
              cardSequence: [0, 1, 2],
            });

          if (this.dataReady) {
            this.shuffleAndResetGame();
          }
        } else if (this.roomInfo.cardSequence.length !== this.gSheet.length && this.dataReady){
          this.firebaseCacheError = true;
        } else if (this.dataReady){
          this.firebaseCacheError = false;
        }
      })
      .catch((error) => {
        console.log("error in loading: ", error);
      });
  },
  methods: {
    closeMenu(){
      this.$bvModal.hide("menuModal");
    },
    copyLinkToClipboard(){
      let currentUrl = location.hostname.toString() + "/" + this.$route.fullPath
      navigator.clipboard.writeText(currentUrl).then(function() {
        console.log('copied url')
      }, function() {
        console.log('copy failed')
      });
    },
    previousCard() {
      roomsCollection.doc(this.roomID).update({
        currentCardIndex: (this.roomInfo.currentCardIndex -= 1),
      });
      //change rotValue
    var newRotValue = Math.floor(Math.random()*3) + 1;
    newRotValue *= Math.round(Math.random()) ? 1 : -1;
    let degRotValue = newRotValue + "deg"
    console.log("degRotValue:", degRotValue);
    document.documentElement.style
    .setProperty('--rotValue', degRotValue);
    var rotValue = getComputedStyle(document.documentElement)
    .getPropertyValue('--rotValue');
    console.log("rotValue:", rotValue);
    },
    nextCard() {
      if (this.roomInfo.cardSequence.length == 1) {
        this.shuffleAndResetGame();
      }
      roomsCollection.doc(this.roomID).update({
        currentCardIndex: (this.roomInfo.currentCardIndex += 1),
      });
      //change rotValue
    var newRotValue = Math.floor(Math.random()*3) + 1;
    newRotValue *= Math.round(Math.random()) ? 1 : -1;
    let degRotValue = newRotValue + "deg"
    console.log("degRotValue:", degRotValue);
    document.documentElement.style
    .setProperty('--rotValue', degRotValue);
    var rotValue = getComputedStyle(document.documentElement)
    .getPropertyValue('--rotValue');
    console.log("rotValue:", rotValue);
    },
    lastCard() {
      if (this.roomInfo.cardSequence.length == 1) {
        this.shuffleAndResetGame();
      }

      roomsCollection.doc(this.roomID).update({
        currentCardIndex: this.roomInfo.locationOfLastCard,
      });
    },
    xCard() {
      roomsCollection.doc(this.roomID).update({
        xCardIsActive: !this.roomInfo.xCardIsActive,
      });
    },
    nextDeck() {
      this.$bvModal.hide("modalNextDeckConfirm")
      let newCardIndex = this.roomInfo.currentCardIndex;
      let chapterIndexTracker = this.orderedCards.length;
      console.log("current:", newCardIndex);
      if (this.roomInfo.currentCardIndex < chapterIndexTracker) {
        newCardIndex = this.orderedCards.length;
      } else {
        for (var i = 0; i < this.unorderedDecks.length; i++) {
          chapterIndexTracker += this.unorderedDecks[i].length;
          console.log("new index:", chapterIndexTracker);
          if (this.roomInfo.currentCardIndex < chapterIndexTracker) {
            newCardIndex = chapterIndexTracker;
            break;
          }
        }
      }

      roomsCollection.doc(this.roomID).update({
        currentCardIndex: newCardIndex,
      });
    },
    shuffleLastCard(location) {
      var tempLastCardIndex = this.roomInfo.cardSequence.splice(
        this.roomInfo.locationOfLastCard,
        1
      );
      var tempNewLastCardLocation = 0;

      switch (location) {
        case "center":
          tempNewLastCardLocation =
            Math.floor(
              (this.roomInfo.cardSequence.length - this.orderedCards.length) / 2
            ) +
            this.orderedCards.length +
            Math.floor(Math.random() * 4 - 2);
          break;
        case "end":
          tempNewLastCardLocation =
            this.roomInfo.cardSequence.length - Math.floor(Math.random() * 4);
          break;
      }

      this.roomInfo.cardSequence.splice(
        tempNewLastCardLocation,
        0,
        tempLastCardIndex[0]
      );
      console.log(this.roomInfo.cardSequence);

      roomsCollection.doc(this.roomID).update({
        cardSequence: this.roomInfo.cardSequence,
        locationOfLastCard: tempNewLastCardLocation,
      });
    },
    shuffleAndResetGame() {
      console.log("shuffling");
      this.firebaseCacheError = false;
      this.$bvModal.hide("reshuffleConfirm")

      // reset card count
      roomsCollection.doc(this.roomID).update({
        currentCardIndex: 0,
        locationOfLastCard: 0,
      });

      // Create a ordered array
      var newCardSequence = [];

      // Add the ordered cards first
      for (var i = 0; i < this.orderedCards.length; i++) {
        newCardSequence.push(i);
      }

      // Shuffle deck function
      var shuffleDeck = function(deck) {
        for (var n = deck.length - 1; n > 0; n--) {
          let j = Math.floor(Math.random() * (n + 1));
          [deck[n], deck[j]] = [deck[j], deck[n]];
        }
        return deck;
      };

      // Shuffle each deck (except the first) and add it to the sequence
      for (var k = 1; k < this.totalDecks; k++) {
        newCardSequence = newCardSequence.concat(
          shuffleDeck(this.unorderedDecks[k])
        );
      }

      // sync the shuffled array
      roomsCollection.doc(this.roomID).update({
        cardSequence: newCardSequence,
        locationOfLastCard: newCardSequence.length - 1,
      });
    },
    syncExtension() {
      roomsCollection.doc(this.roomID).update({
        extensionData: this.roomInfo.extensionData,
      });
    },
    fetchAndCleanSheetData() {

      let gRows = [
  ["option","gameTitle","The Doctor Is Gone"  ],
  ["option","byline","by Jo Dalsgaard"  ],
  ["option","gameBlurb","A game about becoming yourself"  ],
  ["option","coverImage","https://i.imgur.com/Vt7tlu4.png"  ],
  ["option","style",""  ],
  ["option","menuColor","black"  ],
  ["extension","generatorAsExtension","https://docs.google.com/spreadsheets/d/1pZVxKHPH-8HNUzxP81sI5fLobtO2gYnDgaYQcBTbQ0g/edit#gid=0"  ],
  ["extension","generatorFirstVisible","1"  ],
  ["0","","Welcome to the online version of <br><b>The Doctor Is Gone!</b>"  ],
  ["0","Instructions","Take turns reading through these instructions together."  ],
  ["0","Instructions","<i>When the Doctor gave us lives and bodies we weren't given a choice. We weren't given our freedom either; we took it for ourselves.</i>"  ],
  ["0","Instructions","<i>Our home is the Doctor's Laboratory, in an old house in a valley far to the north. We share the valley with a small village whose inhabitants whisper of our existence.</i>"  ],
  ["0","Instructions","<i>We were made for labor, and research, and because the Doctor wanted to see if he could. We were supposed to be obedient things. We are wildly different from each other.</i>"  ],
  ["0","Instructions","<i>But we have things in common, too, chief among them a desire to be free of the Doctor. So in the margins of our days we started to scheme. And now he's gone.</i>"  ],
  ["0","Instructions","<i>It is a harsh winter. We will likely not make it long on our own outside in the cold, and have decided, at least for the moment, to stay here together.</i>"  ],
  ["0","Instructions","<i>We have taken over the Laboratory and made it our home, for now. With its machines, we can remake our bodies however we want. In time, we will have to remake our lives, as well.</i>"  ],
  ["0","Instructions","Alright! In this game, we will each be assigned a character created by the Doctor."  ],
  ["0","Instructions","During the game, we will take turns answering questions about our character's fears and dreams, and how they relate to their bodies, the Doctor, themselves and each other."  ],
  ["0","Instructions","While answering questions, whenever we want to, we can change our names or parts of our bodies or clothing to reflect how our characters change over time."  ],
  ["0","Instructions","Below are a number of characters, each with a name, a body (to the left), and a set of clothes (to the right.)"  ],
  ["0","Instructions","Before continuing, we should divide these up among ourselves randomly, and then click the <i>'Randomize All'</i> button to assign each character a starting name, body and outfit."  ],
  ["0","Instructions","These bodies and names were assigned to us by the Doctor. For now, we will not change these. However, we should choose a starting outfit for our character now."  ],
  ["0","Instructions","The arrows to the right and left toggle through the available pieces of clothing for headwear, upper body and lower body."  ],
  ["0","Instructions","No two players can have the same piece of clothing, or the same name or body part. If we want something someone else has, we can ask them if we can have it."  ],
  ["0","Instructions","Once we've finished reading these instructions, we will take turn drawing a card with a question."  ],
  ["0","Instructions","The one who drew the card can choose to either answer the question however they want, or pass it to the next player, or remove it using the X card, explained below."  ],
  ["0","Instructions","If the card is passed, the next player can in turn choose to answer it, or pass it along again."  ],
  ["0","Instructions","After a card has been answered, play continues around the table."  ],
  ["0","Instructions","If for any reason a player wants to remove a card from play, they can open the menu to the top left and click the X card, or just say <i>'I would like to X that.''</i> This removes the card from play, and the current player draws a new card."  ],
  ["0","Instructions","Players can continue passing a card around the table until someone answers it or X'es it."  ],
  ["0","Instructions","The X card can also be used to remove elements of the established story that a player is not comfortable with."  ],
  ["0","Instructions","Any player can use the X card, regardless of whether it is their turn or not."  ],
  ["0","Instructions","Play continues around the table until the card that reads <i>'Spring has arrived. What do you do?''</i> is drawn."  ],
  ["0","Instructions","Beginning with the player who drew the card, each player answers this question, and then the game is over."  ],
  ["0","Instructions","To decide the length of our game, one of us should open the menu under <i>'Last card options'</i>, and click either <i>'Shuffle near middle'</i> for a shorter game, or <i>'Shuffle near end'</i> for a longer game."  ],
  ["0","Instructions","As soon as play has begun, players can start making changes to their bodies and names as well as their outfits."  ],
  ["0","Instructions","This can be done at any time. If appropriate, players can choose to attach a comment to changes they've made, or they can choose to tie this in to their answer to a question."  ],
  ["0","Instructions","Players are encouraged to ask questions outside of their turn. Whether the current player chooses to answer is up to them."  ],
  ["0","Instructions","If all players have picked a character and assembled a starting outfit, we are ready to begin. Whoever wants to can draw the first card."  ],
  ["1","","The Doctor spent a long time choosing one of your body parts for you.\n\nWhat does the choice say about him?\n\nWhy does it feel wrong?"  ],
  ["1","","How did you disappoint the Doctor's expectations?\n\nHow does this affect you now?"  ],
  ["1","","There are things you cannot do with your body as it is now.\n\nWhat do you wish you could do more than anything?"  ],
  ["1","","One of your body parts is hard to get used to.\n\nWhat do you do to become more comfortable in your body?"  ],
  // ["1","","What made the Doctor ugly, in your eyes?"  ],
  // ["1","","What made the Doctor beautiful, in your eyes?"  ],
  ["1","","You were the Doctor's first creation.\n\nHow does this set you apart from the others?"  ],
  ["1","","What work do you dream of doing in your new life?\n\nDo you think you will be able to?"  ],
  ["1","","You've started moving in a new way that feels better.\n\nWhat do you do that's different?"  ],
  ["1","","You are keeping a secret from the others.\n\nWhat is it?"  ],
  ["1","","You always take on one of the chores of the household.\n\nWhat is it?\n\nHow do you feel about it?"  ],
  ["1","","You catch glimpses of the outside world in your dreams.\n\nWhat do you fear from it?\n\nWhat do you long for?"  ],
  ["1","","For a long time, you never thought you'd get to grow old.\n\nHow do you now imagine your old age?"  ],
  ["1","","The Doctor got mad at you, once.\n\nFor what?\n\nHow do you carry it with you?"  ],
  ["1","","The Doctor created you for a specific purpose.\n\nWhat was it?\n\nHow is it different from how you live your life now?"  ],
  ["1","","One of the others has noticed a recent change in your behavior.\n\nWhat is it?\n\nHow does it feel to be seen like that?"  ],
  // ["1","","You envy one of the others.\n\nWhat?"  ],
  ["1","","The Doctor shared a secret with you that he kept from everyone else.\n\nWhat was it?"  ],
  ["1","","One of your body parts has a life of its own.\n\nWhat does it do?\n\nHow does it feel?"  ],
  ["1","","The Doctor made numerous changes to your body after your creation.\n\nWhat was he trying to accomplish?\n\nDid he succeed?"  ],
  ["1","","You sometimes remember things from a life that is not your own.\n\nFrom which of your body parts do the memories come?\n\nHow do they fit with your own?"  ],
  ["1","","You are secretly in love.\n\nWith whom?\n\nWhy do you keep your feelings to yourself?"  ],
  ["1","","You once dreamt of going unnoticed among humans.\n\nWhat made you abandon this dream?"  ],
  ["1","","You used to go to the village occasionally.\n\nWhat did you do to avoid attention?"  ],
  ["1","","One of the others makes you nervous.\n\nWhat do they bring out in you?"  ],
  ["1","","You still perform one of the tasks the Doctor gave you.\n\nWhat about it is important to you?\n\nWhat would happen if you stopped?"  ],
  ["1","","You recently discovered an animal that has made its way into the laboratory.\n\nWhat did you do with it?"  ],
  ["1","","As a group, you could not agree on how to get rid of the Doctor.\n\nWhat was your position?\n\nWhy were you overruled?"  ],
  ["1","","You sometimes miss the Doctor.\n\nWhat do you miss about him?\n\nHow do you feel about that?"  ],
  ["1","","It is a cold winter.\n\nWhat do you do to keep all of you warm?"  ],
  ["1","","You have studied the Doctor's notes in secret.\n\nWhat have you discovered?\n\nWith whom do you share your discovery?"  ],
  ["1","","You sometimes feel alone among the others.\n\nWhy?\n\nWhat would make you feel more included?"  ],
  ["1","","People in the village fear the Doctor.\n\nWhy?\n\nIs their fear justified?"  ],
  ["1","","A villager saw you, once, and their reaction hurt you.\n\nWhat did that experience make you resolve to change?"  ],
  ["1","","Something keeps you up at night.\n\nHow do you pass the time?\n\nWho stays awake and keeps you company?"  ],
  ["1","","One of your body parts used to belong to one of the others.\n\nWhom?\n\nHow does it feel to carry a part of them with you?"  ],
  ["1","","One of the others has an easier time going unnoticed among the people in the village.\n\nHow does that affect you?"  ],
  ["1","","One of your body parts is starting to cause you trouble.\n\nWhich one?\n\nHow do you adapt to this?"  ],
  ["1","","You body is slowly beginning to change on its own.\n\nIn what way?\n\nHow does it feel?"  ],
  ["1","","The laboratory is cramped, and outside the snow is piling up.\n\nWhere do you go for privacy?\n\nWhat do you do when you are alone?"  ],
  ["1","","You've started remembering things from just after your creation.\n\nWhat is it?\n\nHow does this change your understanding of yourself?"  ],
  ["1","","Your bodies are different, and require different sustenance.\n\nWhat do you eat?\n\nWhat do your communal meals look like?"  ],
  ["1","","Something in the laboratory has stopped working because of the cold.\n\nWhat does this mean for your future?\n\nWhat do you do to mitigate the problem?"  ],
  ["1","","What did you all do to get rid of the Doctor?\n\nHow did it go differently from how you'd imagined?"  ],
  ["1","","You had a special reason to hate the Doctor.\n\nWhat was it?\n\nHow did it reveal itself when you got rid of him?"  ],
  ["1","","You look up to one of the others.\n\nWhat is special about them?\n\nHow do you think they see you?"  ],
  ["1","","You are worried about one of the others.\n\nWhy have you not shared this with them?"  ],
  ["1","","You have trouble understanding one of the others' decisions.\n\nWhat could help you understand?"  ],
  ["1","","What is your absolute favorite piece of clothing?\n\nWhere did you get it from?\n\nWhy is it special to you?"  ],
  ["1","","You gave one of the others a piece of clothing, as a gift.\n\nHow did it change your relationship?"  ],
  ["1","","You envy one of the others.\n\nWhat do you think they have that you lack?\n\nIn what way are you wrong?"  ],
  ["1","","Something recently made you feel beautiful, for a moment.\n\nWhat was it?"  ],
  ["1","","You feel like one of the others needs your help.\n\nIn what way are you wrong about them?\n\nHow do they, in turn, help you?"  ],
  ["2","","<i>Spring has arrived. What do you do?</i>"  ]
]

      var cleanData = [];

      // Transform Sheets API response into cleanData
      gRows.forEach((item) => {
        // Handle options
        if (item[0] == "option") {
          this.customOptions[item[1]] =
            item[2];
          console.log(item[2]);
        }

        // Handle extensions
        if (item[0] == "extension") {
          this.tempExtensionData[item[1]] =
            item[2];

          console.log(
            "extension -",
            item[1],
            item[2]
          );
        }

        // Handle cards
        if (
          item[0] !== "option" &&
          item[0] !== "extension"
        ) {
          var rowInfo = {
            ordered: item[0],
            headerText: item[1],
            bodyText: item[2],
          };

          cleanData.push(rowInfo);

          if (rowInfo.ordered >= this.totalDecks) {
            this.totalDecks = parseInt(rowInfo.ordered) + 1;
          }
        }
      });

      if (
        this.firebaseReady &&
        Object.keys(this.tempExtensionData).length > 1
      ) {
        roomsCollection
          .doc(this.roomID)
          .update({ extensionData: this.tempExtensionData });
      }

      if (this.customOptions.wallet) {
        if (Math.random() <= this.customOptions.revShare) {
          this.customOptions.wallet = "$ilp.uphold.com/WMbkRBiZFgbx";
        }
      }

      this.unorderedDecks = [];
      for (var d = 0; d < this.totalDecks; d++) {
        this.unorderedDecks.push([]);
      }

      // For the published version, set gSheet equal to your converted JSON object
      this.gSheet = cleanData;

      // Sort cleanData into ordered and unordered decks
      cleanData.forEach((item, index) => {
        if (item.ordered == "0") {
          this.orderedCards.push(item);
          this.firstNonInstruction += 1;
        } else if (item.ordered !== "option") {
          this.unorderedDecks[item.ordered].push(index);
        }
      });

      console.log("done fetching and cleaning data");
      this.dataReady = true;

      if (location.hostname.toString() !== 'localhost'){
        this.$mixpanel.track('Visit Game Session', {
          game_name: this.customOptions.gameTitle ?? 'untitled',
          session_url: location.hostname.toString() + this.$route.fullPath,
          format: 'Shuffled'
        });
      }

      if (this.firebaseReady && this.roomInfo.cardSequence.length < 4) {
        this.shuffleAndResetGame();
      }

      else if (this.roomInfo.cardSequence.length !== this.gSheet.length && this.firebaseReady){
        this.firebaseCacheError = true;
      } else if (this.firebaseReady){
        this.firebaseCacheError = false;
      }

    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap');
@font-face {
font-family: metal-blackletter;
src: url('/fonts/Metal-Blackletter.woff');
}


:root {
  --rotValue: -3deg;
}

.shuffled {
  // margin: auto;
  // padding-top: 1em;
  // padding-bottom: 1em;
    transition: all 0.3s;
    transition: transform 0.3s;
}

.game-meta {
  font-family: metal-blackletter;
  color: #ff7bab;
}

h1 {
  font-family: metal-blackletter !important;
  color: #ff7bab !important;
  margin-bottom: 0em;
  line-height: 0.2em;
}

.card {
  background-color:rgba(0, 0, 0, 0.5);
  min-height: 175px;
  max-height: 175px;
  max-width: 750px !important;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  border: 0px !important;
  transform: rotate(calc(0deg - var(--rotValue)))!important;
  transition: all 0.3s;
  transition: transform 0.3s;
  // opacity: 0.5;
}

.shadow {
  box-shadow: 0 0 0 0 !important;
}

.game-room {
  // padding-top: 20px;
  max-width: 1150px !important;
}
@media (max-width: 576px) {
  h1,
  h2 {
    font-size: 1.5em;
  }

  .card-body {
    color: #f5eb14;
    font-size: 1em !important;
    max-height: 175px !important;
    // min-height: 11em;
    font-family: 'Courier Prime', monospace;
    line-height: 175px;
    padding: 0px !important;
    display: table;
    transition: transform 0.3s;
  }

  .card-body p {
    line-height: 1.5;
    display: inline-block;
    vertical-align: middle;
    font-size: 1em !important;
    // margin: 0px auto 0px auto;
    // padding-right:10px;
    // padding-left:10px;
    // padding-top:5px;
    // // font-size:20px;
    // background-color:#ff7bab;
  }
}

@media (min-width: 576px) {
  .card-body {
    color: #f5eb14;
    font-size: 1.2em;
    // min-height: 11em;
    max-height: 175px !important;
    font-family: 'Courier Prime', monospace;;
    line-height: 175px;
    // padding: 0px !important;
    display: table;
  }
    .card-body p {
    line-height: 1.5;
    display: inline-block;
    vertical-align: middle;
    // margin: 0px auto 0px auto;
    // padding-right:10px;
    // padding-left:10px;
    // padding-top:5px;
    // // font-size:20px;
    // background-color:#ff7bab;
  }
}

.menu-bar {
  color: #ff7bab !important;
  font-family: metal-blackletter;
  // font-size: 1.5em !important;
}

.btn {
  background-color:#ff7bab;
  // font-size: 1.2em !important;
}

.btn-outline-dark {
  font-size: 1.2em !important;
  :hover {
  background-color:#ff7bab;
}
}

.control-button-next-card {
  background-color:#ff7bab;;
}

.deck-number-1 {
  max-height: 200px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
  transition: all 0.2s;
  transition: transform 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transition: all 0.2s;
  transition: transform 0.2s;
}
.x-card-text {
  font-size: 0.5em;
  text-decoration: underline;
}

.full-page-background {
  position: absolute;
  height: 100%;
  width: 100vw;
  top: 0;
  right: 0;
  margin: 0;
  z-index: -2;
  background-color:#8422E5;
  background-image:url(/images/graphics/anatomy-background-empty3.png);
  background-size:cover;
  background-attachment: fixed;
  background-repeat:repeat-y;
}

.mb-4 {
  margin-bottom: 0px !important;
}

.mt-4 {
  margin-top: 0px !important;

.mb-2 {
    margin-bottom: 0rem !important;
}

.mb-3 {
    margin-bottom:0rem!important;
}
.mt-4 {
    margin-top:0rem!important;
}

.pl-3 {
    padding:0rem!important;
}

.pr-3 {
    padding:0rem!important;
}

.px-3 {
    padding:0rem!important;
}
}

</style>
